import { handleActions, createAction } from "redux-actions";
import extractApiError from "@utils/extract-api-error";
import {
    deleteRoleEntitiesAPI,
    getActionGroupsAPI,
    getMyProjectPermissionsAPI,
    getRoleAPI,
    getRolesAPI,
    updateRoleActionsAPI,
    updateRoleAPI,
    createRoleEntitiesAPI,
} from "@modules/apis/rolesManagement_v2";
import { SHOW_MENU_OPTIONS } from "@constants";
import { getUsersAPI } from "./apis/user-management-v2";
import { getTeamsAPI } from "./team-management-v2";

const ROLES_MANAGEMENT_GET_ROLES_PENDING = "ROLES_MANAGEMENT_GET_ROLES_PENDING";
const ROLES_MANAGEMENT_GET_ROLES_FAILURE = "ROLES_MANAGEMENT_GET_ROLES_FAILURE";
const ROLES_MANAGEMENT_GET_ROLES_SUCCESS = "ROLES_MANAGEMENT_GET_ROLES_SUCCESS";

const ROLES_MANAGEMENT_GET_ACTION_GROUPS_PENDING = "ROLES_MANAGEMENT_GET_ACTION_GROUPS_PENDING";
const ROLES_MANAGEMENT_GET_ACTION_GROUPS_FAILURE = "ROLES_MANAGEMENT_GET_ACTION_GROUPS_FAILURE";
const ROLES_MANAGEMENT_GET_ACTION_GROUPS_SUCCESS = "ROLES_MANAGEMENT_GET_ACTION_GROUPS_SUCCESS";

const ROLES_MANAGEMENT_GET_ROLE_PENDING = "ROLES_MANAGEMENT_GET_ROLE_PENDING";
const ROLES_MANAGEMENT_GET_ROLE_FAILURE = "ROLES_MANAGEMENT_GET_ROLE_FAILURE";
const ROLES_MANAGEMENT_GET_ROLE_SUCCESS = "ROLES_MANAGEMENT_GET_ROLE_SUCCESS";
const ROLES_MANAGEMENT_RESET_ROLE = "ROLES_MANAGEMENT_RESET_ROLE";

const ROLES_MANAGEMENT_UPDATE_PARSED_ROLES = "ROLES_MANAGEMENT_UPDATE_PARSED_ROLES";

const ROLES_MANAGEMENT_UPDATE_ROLE_PENDING = "ROLES_MANAGEMENT_UPDATE_ROLE_PENDING";
const ROLES_MANAGEMENT_UPDATE_ROLE_FAILURE = "ROLES_MANAGEMENT_UPDATE_ROLE_FAILURE";
const ROLES_MANAGEMENT_UPDATE_ROLE_SUCCESS = "ROLES_MANAGEMENT_UPDATE_ROLE_SUCCESS";

const ROLES_MANAGEMENT_GET_MY_PROJECT_PERMISSIONS_PENDING = "ROLES_MANAGEMENT_GET_MY_PROJECT_PERMISSIONS_PENDING";
const ROLES_MANAGEMENT_GET_MY_PROJECT_PERMISSIONS_FAILURE = "ROLES_MANAGEMENT_GET_MY_PROJECT_PERMISSIONS_FAILURE";
const ROLES_MANAGEMENT_GET_MY_PROJECT_PERMISSIONS_SUCCESS = "ROLES_MANAGEMENT_GET_MY_PROJECT_PERMISSIONS_SUCCESS";

const ROLES_MANAGEMENT_RESET_PROJECT_PERMISSIONS = "ROLES_MANAGEMENT_RESET_PROJECT_PERMISSIONS";

const ROLES_MANAGEMENT_GET_USERS_PENDING = "ROLES_MANAGEMENT_GET_USERS_PENDING";
const ROLES_MANAGEMENT_GET_USERS_SUCCESS = "ROLES_MANAGEMENT_GET_USERS_SUCCESS";
const ROLES_MANAGEMENT_GET_USERS_FAILURE = "ROLES_MANAGEMENT_GET_USERS_FAILURE";
const ROLES_MANAGEMENT_UPDATE_USERS_PARAMS = "ROLES_MANAGEMENT_UPDATE_USERS_PARAMS";

const ROLES_MANAGEMENT_GET_TEAMS_PENDING = "ROLES_MANAGEMENT_GET_TEAMS_PENDING";
const ROLES_MANAGEMENT_GET_TEAMS_SUCCESS = "ROLES_MANAGEMENT_GET_TEAMS_SUCCESS";
const ROLES_MANAGEMENT_GET_TEAMS_FAILURE = "ROLES_MANAGEMENT_GET_TEAMS_FAILURE";
const ROLES_MANAGEMENT_UPDATE_TEAMS_PARAMS = "ROLES_MANAGEMENT_UPDATE_TEAMS_PARAMS";

const ROLES_MANAGEMENT_GET_ASSIGNABLE_USERS_PENDING = "ROLES_MANAGEMENT_GET_ASSIGNABLE_USERS_PENDING";
const ROLES_MANAGEMENT_GET_ASSIGNABLE_USERS_SUCCESS = "ROLES_MANAGEMENT_GET_ASSIGNABLE_USERS_SUCCESS";
const ROLES_MANAGEMENT_GET_ASSIGNABLE_USERS_FAILURE = "ROLES_MANAGEMENT_GET_ASSIGNABLE_USERS_FAILURE";
const ROLES_MANAGEMENT_RESET_ASSIGNABLE_USERS = "ROLES_MANAGEMENT_RESET_ASSIGNABLE_USERS";
const ROLES_MANAGEMENT_UPDATE_ASSIGNABLE_USERS_PARAMS = "ROLES_MANAGEMENT_UPDATE_ASSIGNABLE_USERS_PARAMS";

const ROLES_MANAGEMENT_GET_ASSIGNABLE_TEAMS_PENDING = "ROLES_MANAGEMENT_GET_ASSIGNABLE_TEAMS_PENDING";
const ROLES_MANAGEMENT_GET_ASSIGNABLE_TEAMS_SUCCESS = "ROLES_MANAGEMENT_GET_ASSIGNABLE_TEAMS_SUCCESS";
const ROLES_MANAGEMENT_GET_ASSIGNABLE_TEAMS_FAILURE = "ROLES_MANAGEMENT_GET_ASSIGNABLE_TEAMS_FAILURE";
const ROLES_MANAGEMENT_RESET_ASSIGNABLE_TEAMS = "ROLES_MANAGEMENT_RESET_ASSIGNABLE_TEAMS";
const ROLES_MANAGEMENT_UPDATE_ASSIGNABLE_TEAMS_PARAMS = "ROLES_MANAGEMENT_UPDATE_ASSIGNABLE_TEAMS_PARAMS";

const ROLES_MANAGEMENT_REMOVE_ROLE_ENTITIES_PENDING = "ROLES_MANAGEMENT_REMOVE_ROLE_ENTITIES_PENDING";
const ROLES_MANAGEMENT_REMOVE_ROLE_ENTITIES_SUCCESS = "ROLES_MANAGEMENT_REMOVE_ROLE_ENTITIES_SUCCESS";
const ROLES_MANAGEMENT_REMOVE_ROLE_ENTITIES_FAILURE = "ROLES_MANAGEMENT_REMOVE_ROLE_ENTITIES_FAILURE";

const ROLES_MANAGEMENT_CREATE_ROLE_ENTITIES_PENDING = "ROLES_MANAGEMENT_CREATE_ROLE_ENTITIES_PENDING";
const ROLES_MANAGEMENT_CREATE_ROLE_ENTITIES_SUCCESS = "ROLES_MANAGEMENT_CREATE_ROLE_ENTITIES_SUCCESS";
const ROLES_MANAGEMENT_CREATE_ROLE_ENTITIES_FAILURE = "ROLES_MANAGEMENT_CREATE_ROLE_ENTITIES_FAILURE";

const initialState = {
    actionGroups: {
        data: null,
        pending: false,
        error: null,
    },
    roles: {
        data: null,
        pending: false,
        error: null,
    },
    role: {
        data: null,
        parsedData: null, //Note: General/Specific, 도메인 별로 권한을 묶은 데이터
        pending: false,
        error: null,
    },
    projectPermissions: {
        data: null,
        pending: false,
        error: null,
    },
    users: {
        pending: false,
        error: false,
        totalCount: 0,
        results: [],
        params: {
            keywordType: "name",
            keyword: "",
            offset: 0,
            limit: 50,
            tokenPaginationInfo: [],
        },
    },
    teams: {
        pending: false,
        error: false,
        totalCount: 0,
        results: [],
        params: {
            keywordType: "name",
            keyword: "",
            offset: 0,
            limit: 50,
            tokenPaginationInfo: [],
        },
    },
    assignableTeams: {
        pending: false,
        error: false,
        totalCount: 0,
        results: [],
        params: {
            keywordType: "name",
            keyword: "",
            offset: 0,
            limit: 50,
        },
        submitPending: false,
        submitError: null,
    },
    assignableUsers: {
        pending: false,
        error: false,
        totalCount: 0,
        results: [],
        params: {
            keywordType: "name",
            keyword: "",
            offset: 0,
            limit: 50,
        },
        submitPending: false,
        submitError: null,
    },
    pending: null, //삭제,
};

export default handleActions(
    {
        [ROLES_MANAGEMENT_GET_ROLES_PENDING]: (state) => ({
            ...state,
            roles: {
                ...initialState.roles,
                pending: true,
            },
        }),
        [ROLES_MANAGEMENT_GET_ROLES_FAILURE]: (state, action) => ({
            ...state,
            roles: {
                ...state.roles,
                error: extractApiError(action.payload),
                pending: false,
            },
        }),
        [ROLES_MANAGEMENT_GET_ROLES_SUCCESS]: (state, action) => ({
            ...state,
            roles: {
                ...state.roles,
                data: action.payload,
                pending: false,
            },
        }),
        [ROLES_MANAGEMENT_GET_ACTION_GROUPS_PENDING]: (state) => ({
            ...state,
            actionGroups: {
                ...initialState.actionGroups,
                pending: true,
            },
        }),
        [ROLES_MANAGEMENT_GET_ACTION_GROUPS_FAILURE]: (state, action) => ({
            ...state,
            actionGroups: {
                ...state.actionGroups,
                pending: false,
                error: action.payload,
            },
        }),
        [ROLES_MANAGEMENT_GET_ACTION_GROUPS_SUCCESS]: (state, action) => ({
            ...state,
            actionGroups: {
                ...state.actionGroups,
                pending: false,
                data: action.payload.data,
                originalData: action.payload.originalData,
            },
        }),
        [ROLES_MANAGEMENT_UPDATE_PARSED_ROLES]: (state, action) => ({
            ...state,
            role: {
                ...state.role,
                parsedData: action.payload,
            },
        }),
        [ROLES_MANAGEMENT_GET_ROLE_PENDING]: (state) => ({
            ...state,
            role: {
                ...initialState.role,
                pending: true,
            },
        }),
        [ROLES_MANAGEMENT_GET_ROLE_FAILURE]: (state, action) => ({
            ...state,
            role: {
                ...state.role,
                error: extractApiError(action.payload),
                pending: false,
            },
        }),
        [ROLES_MANAGEMENT_GET_ROLE_SUCCESS]: (state, action) => ({
            ...state,
            role: {
                ...state.role,
                data: action.payload,
                pending: false,
            },
        }),
        [ROLES_MANAGEMENT_RESET_ROLE]: (state, action) => ({
            ...state,
            role: { ...initialState.role },
        }),
        [ROLES_MANAGEMENT_GET_MY_PROJECT_PERMISSIONS_PENDING]: (state) => ({
            ...state,
            projectPermissions: {
                ...state.projectPermissions,
                pending: true,
            },
        }),
        [ROLES_MANAGEMENT_GET_MY_PROJECT_PERMISSIONS_FAILURE]: (state, action) => ({
            ...state,
            projectPermissions: {
                ...state.projectPermissions,
                data: null,
                error: action.payload,
                pending: false,
            },
        }),
        [ROLES_MANAGEMENT_GET_MY_PROJECT_PERMISSIONS_SUCCESS]: (state, action) => ({
            ...state,
            projectPermissions: {
                ...state.projectPermissions,
                data: action.payload,
                pending: false,
            },
        }),
        [ROLES_MANAGEMENT_RESET_PROJECT_PERMISSIONS]: (state) => ({
            ...state,
            projectPermissions: {
                data: null,
                pending: false,
                error: null,
            },
        }),
        [ROLES_MANAGEMENT_GET_USERS_PENDING]: (state) => ({
            ...state,
            users: {
                ...initialState.users,
                pending: true,
            },
        }),
        [ROLES_MANAGEMENT_GET_USERS_FAILURE]: (state, action) => ({
            ...state,
            users: {
                ...state.users,
                error: action.payload,
                pending: false,
            },
        }),
        [ROLES_MANAGEMENT_GET_USERS_SUCCESS]: (state, action) => {
            const { data } = action.payload;
            const newTokenPaginationInfo = [...(state.users.params?.tokenPaginationInfo ?? [])];
            newTokenPaginationInfo[state.users.params.offset] = data.nextToken;

            return {
                ...state,
                users: {
                    ...state.users,
                    totalCount: data.totalCount,
                    results: data.results,
                    pending: false,
                    error: false,
                    params: {
                        ...state.users.params,
                        tokenPaginationInfo: newTokenPaginationInfo,
                    },
                },
            };
        },
        [ROLES_MANAGEMENT_GET_TEAMS_PENDING]: (state) => ({
            ...state,
            teams: {
                ...initialState.teams,
                pending: true,
            },
        }),
        [ROLES_MANAGEMENT_GET_TEAMS_FAILURE]: (state, action) => ({
            ...state,
            teams: {
                ...state.teams,
                error: action.payload,
                pending: false,
            },
        }),
        [ROLES_MANAGEMENT_GET_TEAMS_SUCCESS]: (state, action) => {
            const { data } = action.payload;
            const newTokenPaginationInfo = [...(state.teams.params?.tokenPaginationInfo ?? [])];
            newTokenPaginationInfo[state.teams.params.offset] = data.nextToken;

            return {
                ...state,
                teams: {
                    ...state.teams,
                    totalCount: data.totalCount,
                    results: data.results,
                    pending: false,
                    error: false,
                    params: {
                        ...state.teams.params,
                        tokenPaginationInfo: newTokenPaginationInfo,
                    },
                },
            };
        },
        [ROLES_MANAGEMENT_GET_ASSIGNABLE_USERS_PENDING]: (state, action) => ({
            ...state,
            assignableUsers: {
                ...state.assignableUsers,
                error: null,
                pending: true,
                results: action.payload.clearResults ? [] : state.assignableUsers.results,
            },
        }),
        [ROLES_MANAGEMENT_GET_ASSIGNABLE_USERS_FAILURE]: (state, action) => ({
            ...state,
            assignableUsers: {
                ...state.assignableUsers,
                error: action.payload,
                pending: false,
            },
        }),
        [ROLES_MANAGEMENT_GET_ASSIGNABLE_USERS_SUCCESS]: (state, action) => {
            const { data } = action.payload;

            return {
                ...state,
                assignableUsers: {
                    ...state.assignableUsers,
                    totalCount: data.totalCount,
                    results: data.results,
                    pending: false,
                    error: false,
                    params: {
                        ...state.assignableUsers.params,
                        nextToken: data.nextToken ?? null,
                    },
                },
            };
        },
        [ROLES_MANAGEMENT_GET_ASSIGNABLE_TEAMS_PENDING]: (state, action) => ({
            ...state,
            assignableTeams: {
                ...state.assignableTeams,
                error: null,
                pending: true,
                results: action.payload.clearResults ? [] : state.assignableTeams.results,
            },
        }),
        [ROLES_MANAGEMENT_GET_ASSIGNABLE_TEAMS_FAILURE]: (state, action) => ({
            ...state,
            assignableTeams: {
                ...state.assignableTeams,
                error: action.payload,
                pending: false,
            },
        }),
        [ROLES_MANAGEMENT_GET_ASSIGNABLE_TEAMS_SUCCESS]: (state, action) => {
            const { data } = action.payload;

            return {
                ...state,
                assignableTeams: {
                    ...state.assignableTeams,
                    totalCount: data.totalCount,
                    results: data.results,
                    pending: false,
                    error: false,
                    params: {
                        ...state.assignableTeams.params,
                        nextToken: data.nextToken ?? null,
                    },
                },
            };
        },
        [ROLES_MANAGEMENT_UPDATE_USERS_PARAMS]: (state, action) => ({
            ...state,
            users: {
                ...state.users,
                params: { ...state.users.params, ...action.payload },
            },
        }),
        [ROLES_MANAGEMENT_UPDATE_TEAMS_PARAMS]: (state, action) => ({
            ...state,
            teams: {
                ...state.teams,
                params: { ...state.teams.params, ...action.payload },
            },
        }),
        [ROLES_MANAGEMENT_UPDATE_ASSIGNABLE_USERS_PARAMS]: (state, action) => ({
            ...state,
            assignableUsers: {
                ...state.assignableUsers,
                params: { ...state.assignableUsers.params, ...action.payload },
            },
        }),
        [ROLES_MANAGEMENT_UPDATE_ASSIGNABLE_TEAMS_PARAMS]: (state, action) => ({
            ...state,
            assignableTeams: {
                ...state.assignableTeams,
                params: { ...state.assignableTeams.params, ...action.payload },
            },
        }),
        [ROLES_MANAGEMENT_RESET_ASSIGNABLE_USERS]: (state) => ({
            ...state,
            assignableUsers: {
                ...initialState.assignableUsers,
            },
        }),
        [ROLES_MANAGEMENT_RESET_ASSIGNABLE_TEAMS]: (state) => ({
            ...state,
            assignableTeams: {
                ...initialState.assignableTeams,
            },
        }),
        [ROLES_MANAGEMENT_CREATE_ROLE_ENTITIES_PENDING]: (state) => ({
            ...state,
            assignableTeams: {
                ...state.assignableTeams,
                submitPending: true,
            },
            assignableUsers: {
                ...state.assignableUsers,
                submitPending: true,
            },
        }),
        [ROLES_MANAGEMENT_CREATE_ROLE_ENTITIES_SUCCESS]: (state) => ({
            ...state,
            assignableTeams: {
                ...state.assignableTeams,
                submitPending: false,
            },
            assignableUsers: {
                ...state.assignableUsers,
                submitPending: false,
            },
        }),
        [ROLES_MANAGEMENT_CREATE_ROLE_ENTITIES_FAILURE]: (state, action) => ({
            ...state,
            assignableTeams: {
                ...state.assignableTeams,
                submitPending: false,
                submitError: action.payload,
            },
            assignableUsers: {
                ...state.assignableUsers,
                submitPending: false,
                submitError: action.payload,
            },
        }),
    },
    initialState,
);

export const updateParsedRoles = createAction(ROLES_MANAGEMENT_UPDATE_PARSED_ROLES);
export const resetProjectPermissions = createAction(ROLES_MANAGEMENT_RESET_PROJECT_PERMISSIONS);
export const resetAssignableUsers = createAction(ROLES_MANAGEMENT_RESET_ASSIGNABLE_USERS);
export const resetAssignableTeams = createAction(ROLES_MANAGEMENT_RESET_ASSIGNABLE_TEAMS);
export const resetRole = createAction(ROLES_MANAGEMENT_RESET_ROLE);

const makeActionGroupByPluggable = (actionGroups) => {
    const actionGroupMap = actionGroups.reduce(
        (acc, actionGroup) => {
            const isPluggable = actionGroup.isPluggable ? "specific" : "general";

            const actionDomain = acc[isPluggable].find((domain) => domain.id === actionGroup.domain);

            if (actionDomain) {
                actionDomain.permissions.push(actionGroup);
            } else {
                acc[isPluggable].push({
                    id: actionGroup.domain,
                    permissions: [actionGroup],
                });
            }

            return acc;
        },
        { general: [], specific: [] },
    );

    actionGroupMap.general = actionGroupMap.general.sort((prev, next) => {
        const prevMenuIndex = SHOW_MENU_OPTIONS.findIndex((menu) => menu.name === prev.id);
        const nextMenuIndex = SHOW_MENU_OPTIONS.findIndex((menu) => menu.name === next.id);

        return prevMenuIndex - nextMenuIndex;
    });
    return actionGroupMap;
};

export const getRoles = (projectId, params) => async (dispatch, getState) => {
    const { stage } = getState();

    dispatch({ type: ROLES_MANAGEMENT_GET_ROLES_PENDING });
    try {
        const response = await getRolesAPI(stage.endpoint, projectId, params);
        dispatch({ type: ROLES_MANAGEMENT_GET_ROLES_SUCCESS, payload: response.data });
        return response.data?.nextToken;
    } catch (error) {
        dispatch({ type: ROLES_MANAGEMENT_GET_ROLES_FAILURE, payload: error });
    }
};

export const getActionGroups = (projectId, params) => async (dispatch, getState) => {
    const { stage } = getState();

    dispatch({ type: ROLES_MANAGEMENT_GET_ACTION_GROUPS_PENDING });
    try {
        let nextToken = null;
        const allRoles = [];

        do {
            const response = await getActionGroupsAPI(stage.endpoint, projectId, {
                ...params,
                isAssignable: true,
                nextToken,
            });
            allRoles.push(...(response.data?.results ?? []));
            nextToken = response.data?.nextToken;
        } while (nextToken);

        if (params.scope === "SPACE") {
            do {
                const response = await getActionGroupsAPI(stage.endpoint, projectId, {
                    scope: "PROJECT",
                    isAssignable: true,
                    nextToken,
                });
                allRoles.push(...(response.data?.results ?? []));
                nextToken = response.data?.nextToken;
            } while (nextToken);
        }

        dispatch({
            type: ROLES_MANAGEMENT_GET_ACTION_GROUPS_SUCCESS,
            payload: { data: makeActionGroupByPluggable(allRoles), originalData: allRoles },
        });
    } catch (error) {
        dispatch({ type: ROLES_MANAGEMENT_GET_ACTION_GROUPS_FAILURE, payload: error });
        console.error(error);
    }
};

export const getRole =
    (projectId, id, withoutPending = false) =>
    async (dispatch, getState) => {
        const { stage } = getState();

        if (!withoutPending) {
            dispatch({ type: ROLES_MANAGEMENT_GET_ROLE_PENDING });
        }
        try {
            const response = await getRoleAPI(stage.endpoint, projectId, id);
            dispatch({ type: ROLES_MANAGEMENT_GET_ROLE_SUCCESS, payload: response.data });
            return response?.data;
        } catch (error) {
            dispatch({ type: ROLES_MANAGEMENT_GET_ROLE_FAILURE, payload: error });
        }
    };

export const updateRole = (projectId, roleId, data) => async (dispatch, getState) => {
    const { stage } = getState();

    dispatch({ type: ROLES_MANAGEMENT_UPDATE_ROLE_PENDING });
    try {
        await updateRoleAPI(stage.endpoint, projectId, roleId, data);
        await dispatch(getRole(projectId, roleId, true));
        dispatch({ type: ROLES_MANAGEMENT_UPDATE_ROLE_SUCCESS });
    } catch (error) {
        dispatch({ type: ROLES_MANAGEMENT_UPDATE_ROLE_FAILURE, payload: error });
    }
};

export const updateRoleActions = (projectId, roleId, data) => async (dispatch, getState) => {
    const { stage } = getState();

    dispatch({ type: ROLES_MANAGEMENT_UPDATE_ROLE_PENDING });
    try {
        await updateRoleActionsAPI(stage.endpoint, projectId, roleId, data);
        await dispatch(getRole(projectId, roleId, true));
        dispatch({ type: ROLES_MANAGEMENT_UPDATE_ROLE_SUCCESS });
    } catch (error) {
        dispatch({ type: ROLES_MANAGEMENT_UPDATE_ROLE_FAILURE, payload: error });
    }
};

export const getMyProjectPermissions = () => async (dispatch, getState) => {
    const { stage, project, roleManagementV2 } = getState();

    if (!roleManagementV2.projectPermissions?.data)
        dispatch({ type: ROLES_MANAGEMENT_GET_MY_PROJECT_PERMISSIONS_PENDING });
    try {
        let nextToken = null;
        let results = [];

        do {
            const response = await getMyProjectPermissionsAPI(stage.endpoint, project.id, { nextToken });
            results = results.concat(response.data.results);
            nextToken = response.data?.nextToken;
        } while (nextToken);

        dispatch({
            type: ROLES_MANAGEMENT_GET_MY_PROJECT_PERMISSIONS_SUCCESS,
            payload: results,
        });
    } catch (error) {
        console.error(error);
        dispatch({ type: ROLES_MANAGEMENT_GET_MY_PROJECT_PERMISSIONS_FAILURE, payload: error });
    }
};

export const getRoleUsers =
    ({ params, initLoad }) =>
    async (dispatch, getState) => {
        const { stage, roleManagementV2 } = getState();

        let finalParams = { ...params };

        dispatch({ type: ROLES_MANAGEMENT_GET_USERS_PENDING });
        dispatch({ type: ROLES_MANAGEMENT_UPDATE_USERS_PARAMS, payload: { ...params } });

        if (initLoad) {
            finalParams = { limit: roleManagementV2.users.params.limit, roleId: params.roleId };
        } else {
            finalParams.nextToken = params?.offset > 0 ? params.tokenPaginationInfo[params.offset - 1] : undefined;
        }

        try {
            const response = await getUsersAPI(stage.id, stage.endpoint, null, finalParams);
            dispatch({ type: ROLES_MANAGEMENT_GET_USERS_SUCCESS, payload: response });
        } catch (error) {
            dispatch({ type: ROLES_MANAGEMENT_GET_USERS_FAILURE, payload: error });
            console.error(error);
        }
    };

export const getRoleTeams =
    ({ params, initLoad }) =>
    async (dispatch, getState) => {
        const { stage, roleManagementV2 } = getState();

        let finalParams = { ...params };

        dispatch({ type: ROLES_MANAGEMENT_GET_TEAMS_PENDING });
        dispatch({ type: ROLES_MANAGEMENT_UPDATE_TEAMS_PARAMS, payload: { ...params } });

        if (initLoad) {
            finalParams = { limit: roleManagementV2.teams.params.limit, roleId: params.roleId };
        } else {
            finalParams.nextToken = params?.offset > 0 ? params.tokenPaginationInfo[params.offset - 1] : undefined;
        }

        try {
            const response = await getTeamsAPI(stage.id, stage.endpoint, null, finalParams);
            dispatch({ type: ROLES_MANAGEMENT_GET_TEAMS_SUCCESS, payload: response });
        } catch (error) {
            dispatch({ type: ROLES_MANAGEMENT_GET_TEAMS_FAILURE, payload: error });
            console.error(error);
        }
    };

export const getRoleAssignableUsers =
    ({ params, initLoad }) =>
    async (dispatch, getState) => {
        const { stage, roleManagementV2 } = getState();

        let finalParams = { ...params };

        dispatch({
            type: ROLES_MANAGEMENT_GET_ASSIGNABLE_USERS_PENDING,
            payload: { clearResults: initLoad || !params?.nextToken },
        });
        dispatch({ type: ROLES_MANAGEMENT_UPDATE_ASSIGNABLE_USERS_PARAMS, payload: { ...params } });

        if (initLoad) {
            finalParams = {
                limit: roleManagementV2.assignableUsers.params.limit,
                notWithRoleId: params.notWithRoleId,
            };
        }

        try {
            const response = await getUsersAPI(stage.id, stage.endpoint, null, finalParams);
            response.data.results = !params.nextToken
                ? response.data.results
                : [...roleManagementV2.assignableUsers.results, ...response.data.results];

            dispatch({ type: ROLES_MANAGEMENT_GET_ASSIGNABLE_USERS_SUCCESS, payload: response });
        } catch (error) {
            dispatch({ type: ROLES_MANAGEMENT_GET_ASSIGNABLE_USERS_FAILURE, payload: error });
            console.error(error);
        }
    };

export const getRoleAssignableTeams =
    ({ params, initLoad }) =>
    async (dispatch, getState) => {
        const { stage, roleManagementV2 } = getState();

        let finalParams = { ...params };

        dispatch({
            type: ROLES_MANAGEMENT_GET_ASSIGNABLE_TEAMS_PENDING,
            payload: { clearResults: initLoad || !params?.nextToken },
        });
        dispatch({ type: ROLES_MANAGEMENT_UPDATE_ASSIGNABLE_TEAMS_PARAMS, payload: { ...params } });

        if (initLoad) {
            finalParams = {
                limit: roleManagementV2.assignableTeams.params.limit,
                notWithRoleId: params.notWithRoleId,
            };
        }

        try {
            const response = await getTeamsAPI(stage.id, stage.endpoint, null, finalParams);
            response.data.results = !params.nextToken
                ? response.data.results
                : [...roleManagementV2.assignableTeams.results, ...response.data.results];

            dispatch({ type: ROLES_MANAGEMENT_GET_ASSIGNABLE_TEAMS_SUCCESS, payload: response });
        } catch (error) {
            dispatch({ type: ROLES_MANAGEMENT_GET_ASSIGNABLE_TEAMS_FAILURE, payload: error });
            console.error(error);
        }
    };

export const createRoleEntities = (roleId, data) => async (dispatch, getState) => {
    const { stage } = getState();

    dispatch({ type: ROLES_MANAGEMENT_CREATE_ROLE_ENTITIES_PENDING });
    try {
        await createRoleEntitiesAPI(stage.endpoint, null, roleId, data);
        dispatch({ type: ROLES_MANAGEMENT_CREATE_ROLE_ENTITIES_SUCCESS });
    } catch (error) {
        dispatch({ type: ROLES_MANAGEMENT_CREATE_ROLE_ENTITIES_FAILURE, payload: error });
        console.error(error);
        throw error;
    }
};

export const removeRoleEntities = (roleId, entityId) => async (dispatch, getState) => {
    const { stage } = getState();

    dispatch({ type: ROLES_MANAGEMENT_REMOVE_ROLE_ENTITIES_PENDING });
    try {
        await deleteRoleEntitiesAPI(stage.endpoint, null, roleId, entityId);
        dispatch({ type: ROLES_MANAGEMENT_REMOVE_ROLE_ENTITIES_SUCCESS });
    } catch (error) {
        dispatch({ type: ROLES_MANAGEMENT_REMOVE_ROLE_ENTITIES_FAILURE, payload: error });
        console.error(error);
        throw error;
    }
};
